import COMMON from './common'
import ANALYTICS_MESSAGE from './analytics'
import CAMPAIGN_MESSAGE from './campaign'
import PORTAL_MESSAGE from './portal'
import NETWORK_MESSAGE from './network'
import LEGAL_TEXT_MESSAGE from './legalText'
import PLACEMENT_MESSAGE from './placement'
import LOGIN_MESSAGE from './login'
import BRAND_MESSAGE from './brand'
import DOWNLOAD_MESSAGE from './download'
import VIDEO_MESSAGE from './video'
import QUESTIONNAIRE_MESSAGE from './questionnaire'

const es = {
  COMMON: { ...COMMON },
  ANALYTICS: ANALYTICS_MESSAGE,
  CAMPAIGN: CAMPAIGN_MESSAGE,
  PORTAL: PORTAL_MESSAGE,
  NETWORK: NETWORK_MESSAGE,
  LEGAL_TEXT: LEGAL_TEXT_MESSAGE,
  PLACEMENT: PLACEMENT_MESSAGE,
  LOGIN: LOGIN_MESSAGE,
  BRAND: BRAND_MESSAGE,
  DOWNLOAD: DOWNLOAD_MESSAGE,
  VIDEO: VIDEO_MESSAGE,
  QUESTIONNAIRE: QUESTIONNAIRE_MESSAGE
}

export default es
